import { AbstractCriterion } from './AbstractCriterion';

/**
 * Class representing a specific criterion that extends the abstract criterion.
 */
export class Criterion extends AbstractCriterion {}
